var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('MenuBar'),_c('v-main',{staticStyle:{"background-color":"#2e2f3c","padding-top":"0px"}},[_c('router-view',{key:_vm.$route.name + (_vm.$route.params.id || '')})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }